import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import 'devextreme/data/odata/store';
import devices from 'devextreme/core/devices';
import notify from 'devextreme/ui/notify';
import DataGrid, {
  Column,
  Pager,
  Paging,
  SearchPanel,
  Editing,
  Button as DGButton,
} from 'devextreme-react/data-grid';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import Button from 'devextreme-react/button';
import 'devextreme-react/tag-box';
import { SelectBox } from 'devextreme-react/select-box';
import {
  Form,
  Label,
  SimpleItem,
  RequiredRule,
  EmailRule
} from 'devextreme-react/form';
import { useAuth } from '../../contexts/auth';
import { adminGetUsers, adminGetCompanies, adminUpdateUser, adminDeleteUser,
  adminReaddUser, adminReaddAllUsers, } from '../../api/api'
import { Popup, Position, ToolbarItem } from 'devextreme-react/popup';

const isPhone = devices.current().deviceType === 'phone'

export default function ManageUsers() {
  const { user, refreshSession } = useAuth();
  const [usersList, setUsersList] = useState([]);
  const [companiesList, setCompaniesList] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true)
  const dataGridRef = useRef(null);
  const formRef = useRef(null);

  const permissionsList = [{label:"Admin", value:"admin"}, {label:"AI User", value:"company_aiuser"}, {label:"KB Manager", value:"company_kbmanager"}, {label:"SIF Read-Only", value:"company_sifro"}, 
  {label:"SIF Read-Write", value:"company_sifrw"}, {label:"ESG Read-Only", value:"company_esgro"}, {label:"HSE Read-Only", value:"company_hsero"}]
  const [companiesSelectBoxEditorOptions, setCompaniesSelectBoxEditorOptions] = useState({});


  useEffect(() => {
    if (user.signInUserSession) {
      adminGetCompanies(user, onGetCompaniesSuccess, onError);
    }
  }, [user && user.signInUserSession, user.signInUserSession.idToken.payload]);

  useEffect(() => {
    if (currentUser) {
      setCancelButtonOptions({
        disabled: false,
        text: 'Cancel',
        width: '100%',
        onClick: onCancel,
      });
      setSaveButtonOptions({
        disabled: !(currentUser.email),
        text: 'Save',
        type: 'default',
        width: '100%',
        onClick: onSave,
      });
    }
  }, [currentUser]);

  const onCancel = () => {
    setCurrentUser(null);
  }

  const onSave = async () => {
    setSaveButtonOptions({
      disabled: true,
      text: 'Save',
      type: 'default',
      width: '100%',
      onClick: onSave,
    });
    adminUpdateUser(user, currentUser, onSaveSuccess, onError);
  }

  const onGetUsersSuccess = useCallback((data) => {
    setUsersList(data);
    setLoading(false);
  }, [])

  const onError = useCallback((error) => {
    console.log('error occured')
    if (error.status === 401) {
      refreshSession();
    } else {
      notify("An error has occured. Please try again later.", 'error', 2000);
      console.log(error);
      setLoading(false);
    }
  }, [refreshSession]);

  const onDeleteError = useCallback((error, ) => {
    console.log('error occured')
    if (error.status === 401) {
      refreshSession();
    } else {
      setLoading(true);
      adminGetUsers(user, onGetUsersSuccess, onError);
      notify("An error has occured. Please try again later.", 'error', 2000);
      console.log(error);
    }
  }, [refreshSession]);

  const [cancelButtonOptions, setCancelButtonOptions] = useState({
    disabled: false,
    text: 'Cancel',
    width: '100%',
    onClick: onCancel,
  });

  const [saveButtonOptions, setSaveButtonOptions] = useState({
    disabled: false,
    text: 'Save',
    type: 'default',
    width: '100%',
    onClick: onSave,
  });

  const onReaddSuccess = useCallback((data) => {
     adminGetUsers(user, onGetUsersSuccess, onError);
     notify("The user was re-invited successfully.", 'warning', 5000);
  }, [user, onGetUsersSuccess, onError])

  const onReadd = useCallback((e) => {
    setLoading(true);
    adminReaddUser(user, e.row.data, onReaddSuccess, onError);
  }, [user, onReaddSuccess, onError]);

  const isReaddVisible = useCallback((e) => {
    return e.row.data.user_status === "FORCE_CHANGE_PASSWORD"
  }, []);

  const onReaddAllSuccess = useCallback((data) => {
    adminGetUsers(user, onGetUsersSuccess, onError);
    notify(`${data.length} users were re-invited successfully`, 'warning', 5000);
  }, [user, onGetUsersSuccess, onError])

  const onReaddAll = useCallback( () => {
    let data = {users: usersList.filter(item => item.user_status==="FORCE_CHANGE_PASSWORD")}
    setLoading(true);
    adminReaddAllUsers(user, data, onReaddAllSuccess, onError);
  }, [usersList])

  const onSaveSuccess = useCallback((data) => {
     setCurrentUser(null);
     setLoading(true);
     adminGetUsers(user, onGetUsersSuccess, onError);
  }, [])



  const onGetCompaniesSuccess = useCallback((data) => {
    adminGetUsers(user, onGetUsersSuccess, onError);
    setCompaniesList(data);
    data = data.sort((a,b) => (a.company_name > b.company_name) ? 1 : ((b.company_name > a.company_name) ? -1 : 0))

    setCompaniesSelectBoxEditorOptions(
    {
      showDropDownButton: true,
      activeStateEnabled: true,
      valueExpr: 'company_id',
      displayExpr: 'company_name',
      searchEnabled: true,
      dataSource: data,
      onFocusIn: onInit,
      onValueChanged(e) {
        /*if (formRef != null) {
          console.log('form:', formRef.current);
          console.log('form:', formRef.current.instance !== null);
          if (!(e.value)) {
            formRef.current?.instance?.getEditor('permission').option('value', null)
            formRef.current?.instance?.getEditor('permission').option('readOnly', true)
          } else {

            formRef.current?.instance?.getEditor('permission').option('value', currentUser['permission'])
            formRef.current?.instance?.getEditor('permission').option('readOnly', false)
          }
        }*/
      }
    })
  }, [])

  const removeRow = e => {
    adminDeleteUser(user, e.key, onSaveSuccess, onDeleteError)
  }

  const onInit = useCallback( (e) => {
    console.log("onInit:", e);
    console.log("onInit companiesList:", companiesList);
  }, [companiesList])

  const onAdd = useCallback( () => {
    setCurrentUser(
      {
        company_id: null,
        permission: []
      });
  }, [companiesList])



  const onFormDataChanged = (e) => {
    setSaveButtonOptions({
      disabled: !(currentUser.email),
      text: 'Save',
      type: 'default',
      width: '100%',
      onClick: onSave,
    });
  }

  const permCellRender = (data) => {
    var permDisp = "";
    for (var i=0; i<permissionsList.length; i++) {
      if (data.data.permission.includes(permissionsList[i].value)) {
        permDisp = permDisp + permissionsList[i].label + ", ";
      }
    }
    if (permDisp.length > 0) {
      permDisp = permDisp.slice(0, -2);
    }
    return (
      <>
        {permDisp}
      </>
    );
  }

  const statusCellRender = (data) => {
    var disp = "";
    if (data.data.user_status === "FORCE_CHANGE_PASSWORD") {
      disp="Force Password Change"
    } else if ((data.data.user_status === "CONFIRMED")) {
      disp="Confirmed"
    } else {
      disp=data.data.user_status
    }

    return (
      <>
        {disp}
      </>
    );
  }

  const popupAttributes = useMemo(() => {
      return {
          id: 'elementId',
          class: 'add-user-popup'
      }
  }, []);

  if(!loading) {
    return (
      <React.Fragment>
        <div className="d-flex flex-row justify-content-between align-items-center content-block">
          <h2 className={''}>Manage Users</h2>
          <div className="d-flex flex-row align-items-center content-block pb-1">
            <Button
              type="danger"
              stylingMode="outlined"
              text="Re-Invite All"
              onClick={onReaddAll}
            />
            <div className="px-2"/>
            <Button
              type="default"
              text="Add User"
              onClick={onAdd}
            />
          </div>
        </div>

        <DataGrid
          ref={dataGridRef}
          className={'dx-card wide-card'}
          dataSource={usersList}
          showBorders={false}
          focusedRowEnabled={false}
          defaultFocusedRowIndex={0}
          columnAutoWidth={true}
          columnHidingEnabled={true}
          onRowRemoved={removeRow}
        >

          <Paging defaultPageSize={50} />
          <Pager showPageSizeSelector={true} showInfo={true} />
          <SearchPanel
            visible={true}
            width="250"
            placeholder="Search..."
          />

          <Column
            dataField={'email'}
            caption={'Email'}
            hidingPriority={1}
          />
          <Column
            dataField={'company_name'}
            caption={'Company'}
            hidingPriority={2}
            defaultSortOrder="asc"
          >
            <RequiredRule />
          </Column>
          <Column
            dataField={'user_status'}
            caption={'Status'}
            hidingPriority={3}
            cellRender={statusCellRender}
          />
          <Column
            dataField={'permission'}
            caption={'Permission'}
            hidingPriority={0}
            cellRender={permCellRender}
          />
          <Column type="buttons">
            <DGButton
                text="Edit"
                icon="fas fa-pen fs-6"
                hint="Edit"
                onClick={(e) => {
                  setCurrentUser(e.row.data);
                }}
            />
            <DGButton
                text="Resend"
                icon="far fa-share-square"
                hint="Resend"
                onClick={onReadd}
                visible={isReaddVisible}
            />
            <DGButton name="delete" />
          </Column>

          <Editing
            allowEditing={true}
            mode="popup"
            allowUpdating={true}
            allowDeleting={true}
            // allowAdding={true}
          />
        </DataGrid>



        <Popup
          wrapperAttr={popupAttributes}
          visible={currentUser !== null}
          onHidden={() => setCurrentUser(null)}
          dragEnabled={false}
          showCloseButton={false}
          showTitle={true}
          fullScreen={isPhone}
          title={currentUser?.id?"Edit User":"Add User"}

          width={380}
          height={720}
        >
            <Position at="center" my="center"collision="fit" />
            <ToolbarItem
              widget="dxButton"
              toolbar="bottom"
              location="before"
              options={saveButtonOptions}
            />
            <ToolbarItem
              widget="dxButton"
              toolbar="bottom"
              location="after"
              options={cancelButtonOptions}
            />

            <Form
              ref={formRef}
              id={'form'}
              formData={currentUser}
              labelLocation={'top'}
              onFieldDataChanged={onFormDataChanged}
              onOptionChanged={ (e) => {
                let emailEditor = null;
                /*if (formRef.current?.props?.formData?.id) {
                  emailEditor = formRef.current?.instance.getEditor('email')
                }
                if (formRef.current?.props?.formData?.id) {
                  if (emailEditor) {
                    emailEditor.option('readOnly', true)
                  }

                } else {
                  if (emailEditor) {
                    emailEditor.option('readOnly', false)
                  }

                }*/
              }}
            >
                <SimpleItem
                  dataField="email"
                  editorOptions={{
                    disabled: currentUser?.id
                  }}
                >
                  <Label text="Email"/>
                  <RequiredRule message="Email is required" />
                  <EmailRule message="Email is invalid" />
                </SimpleItem>
                <SimpleItem
                    editorType="dxSelectBox"
                    dataField="company_id"
                    editorOptions={companiesSelectBoxEditorOptions}
                >
                  <Label text="Company Name"/>
                  <RequiredRule message="Company Name is required" />
                </SimpleItem>

                <SimpleItem
                    editorType="dxTagBox"
                    dataField="permission"
                    editorOptions={{
                      items: permissionsList,
                      valueExpr: 'value',
                      displayExpr: 'label',
                    }}
                >
                  <Label text="Permissions"/>
                  <RequiredRule message="At least one permission is required" />
                </SimpleItem>
            </Form>

        </Popup>

      </React.Fragment>
    )
  } else {
    return (
      <div className="d-flex flex-row justify-content-center align-items-center mt-5 pt-5">
          <LoadIndicator
              id="large-indicator"
              height={60}
              width={60}
          />
      </div>
    )
  }
}
